import { LazyModule, registerLazyOrchestrator } from 'owa-bundling';
import { invokeSuggestions, invokeSearch, searchCompleted } from './actions/searchActions';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "TimestreamSearchOrchestration" */ './lazyIndex')
);

// export constants
export { EMPTY_SEARCH_RESPONSE } from './searchConstants';

// Actions are public so external packages can listen to them
export { invokeSuggestions, invokeSearch, searchCompleted } from './actions/searchActions';

// export helpers to process results
export { default as getSearchResultItemsFromResultSet } from './helpers/getSearchResultItemsFromResultSet';
export { default as getSearchResultSetFromEntitySet } from './helpers/getSearchResultSetFromEntitySet';

// Orchestrators are lazy so that we don't pull in code for them until relevant action is called
registerLazyOrchestrator(invokeSuggestions, lazyModule, m => m.invokeSuggestionsOrchestrator);
registerLazyOrchestrator(invokeSearch, lazyModule, m => m.invokeSearchOrchestrator);
registerLazyOrchestrator(searchCompleted, lazyModule, m => m.searchCompletedOrchestrator);
